export default "__VITE_ASSET__CInG2QTt__"